import Styled from 'styled-components'
import { respondTo } from '@/respondTo'

export const LegalContainer = Styled.div`
display: flex;
position:relative;
flex-direction: column;
padding: 2.5rem;
align-items: flex-start;
justify-content:center;
overflow-x:hidden;
gap: 2rem;



${respondTo.tablet_landscape_s`
    padding:4.375rem 2.5rem;
    `}

${respondTo.desktop_xl`
    padding: 4.375rem;
    max-width: 1512px;
   
    `}
`

export const BoxContent = Styled.div`
    display: flex;
    position:relative;
    flex-direction:column;
    align-items: flex-start;
    justify-content:center;
    gap: 0.5rem;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            padding-left: 1.5rem;
            // add dot 
            &::before {
                content: "•";
                position: absolute;
                left: 0;
                color: white;

            }
        }
    }

    
`
